import * as React from 'react'
import * as classnames from 'classnames'
import { Link } from 'react-router-dom'

import { IItem } from '../../../../typings/searchResults'
import { reportBlockClick } from '../../../../common/analytics/homePageAnalytics'

import SearchLink from '../../../containers/searchLinkContainer'
import ItemCard from '../../itemCard'
import ItemCardsLayout from '../../itemCardsLayout'
import Button from '../../button'

import * as styles from './itemsShowcaseBlock.module.css'

interface ICta {
  url: string
  title: string
  urlSearchParams?: undefined
}

interface ISearchCta {
  title: string
  urlSearchParams: {
    [key: string]: string
  }
  url?: undefined
}

interface IProps {
  data: IItem[]
  blockName: string
  title: string
  subtitle?: string
  cta?: ICta | ISearchCta
  evenGrid?: boolean
}

const getCtaButton = ({
  cta,
  blockName,
  cssClass
}: {
  cta?: ICta | ISearchCta
  blockName: string
  cssClass: 'leftButton' | 'lowerButton'
}) => {
  if (!cta) {
    return null
  }

  const commonProps = {
    type: Button.Type.Primary,
    className: styles[cssClass],
    onClick: () => {
      reportBlockClick(blockName, {
        eventLabel: cta.title
      })
    }
  }

  let props

  if (cta.url) {
    props = {
      ...commonProps,
      renderAs: Link,
      to: cta.url
    }
  }

  if (cta.urlSearchParams) {
    props = {
      ...commonProps,
      renderAs: SearchLink,
      locationParams: cta.urlSearchParams
    }
  }

  return <Button {...props}>{cta.title}</Button>
}

const ItemsShowcaseBlock = ({
  data,
  blockName,
  title,
  subtitle,
  cta,
  evenGrid = false
}: IProps) => {
  const gridStyles = classnames(styles.grid, {
    [styles.evenGrid]: evenGrid
  })

  return (
    <section className={styles.root}>
      <div className={styles.wrapper}>
        <ItemCardsLayout viewType="grid" className={gridStyles}>
          <ItemCardsLayout.CardArea className={styles.textArea}>
            <div className={styles.textAreaInner}>
              <header>
                <h2 className={styles.title}>{title}</h2>
                {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
              </header>
              {getCtaButton({ cta, blockName, cssClass: 'leftButton' })}
            </div>
          </ItemCardsLayout.CardArea>

          {data.map((item, index) => (
            <ItemCardsLayout.CardArea key={`${blockName}-${item.id}`}>
              <ItemCard
                listName={`Homepage: ${blockName}`}
                item={item}
                key={item.id}
                index={index}
                viewType="grid"
              />
            </ItemCardsLayout.CardArea>
          ))}
        </ItemCardsLayout>

        {getCtaButton({ cta, blockName, cssClass: 'lowerButton' })}
      </div>
    </section>
  )
}

export default ItemsShowcaseBlock
